import { DataObject, ObjectReference } from "./dataObject";
import { ChannelAllocationStrategy, SiteChannelPool } from "./channelPool";

/**
 * Copyright 2021-2022 Highway9 Networks Inc.
 */
export interface ISite extends DataObject {
  id?: string;
  name: string;
  docVersion?: number;
  description?: string;
  readonly timezone: string;
  location?: {
    latitude: number
    longitude: number;
    name?: string;
    zoom?: number;
    /** @enum {string} "ROADMAP" | "SATELLITE" | "HYBRID" | "TERRAIN" */
    view?: string;
  };
  macroEnbIdList?: number[];
  tacId?: string;
  attributes: string[];
  /** Not Available in the API - remove on PUT call */
  countAPs?: number;
  connectedAPs?: number;
  children?: any;
  overallStatus?: string;
  /** @enum {string} "PRIVATE_CELLULAR" | "CARRIER_GATEWAY" */
  siteService?: string;
  
  siteImage?: {
    imageData?: string;
    imageName?: string;
    imageId?: string;
  }[];
  siteInfo?: {
    floors?: number;
    basements?: number;
    coverageArea?: number;
    occupancy?: number;
    buildingType?: "SINGLE" | "MULTIPLE";
  }
  isCloudGatewayEnabled: boolean;
  cloudGatewayEdge?: ObjectReference;
  edges: EdgeReference[];

  // Property Management
  sitePOCInfo?: {
    landlordName?: string;
    landlordEmail?: string;
    landlordPhoneNumber?: string;
  }

  // Per-site channel pool config — Phase 1: 4G sites only. Sent on create/
  // update for 4G sites and stripped from the payload for non-4G sites.
  channelPool?: SiteChannelPool;

  // Per-site Channel Allocation Strategy — Phase 1: 4G sites only. Default
  // comes from the `Default.Channel.Allocation.Strategy` system setting; an
  // upgrade script populates existing 4G sites.
  channelAllocationStrategy?: ChannelAllocationStrategy;
}

export interface EdgeReference {
  edge: {
    id: string;
    name?: string;
    /**@enum {string} "PRIVATE_CELLULAR" | "CARRIER_GATEWAY" */
    type?: string;
  };
  /** @enum {string} 'PSK' | 'CERTIFICATE' | "DISABLED"; */
  ipsecMode: string;
  /** Only available if edge type is CARRIER_GATEWAY */
   carriers?:  {
    id: string;
    name?: string;
    type?: string;
    reserved?: boolean;
  }[]}

export const defaultSite: ISite = {
  name: "",
  description: "",
  location: {
    latitude: 37.26534961208239,
    longitude: -122.04076419999998,
    name: "20972 Saratoga Hills Rd, Saratoga, CA 95070, USA",
  },
  tacId: "",
  siteService: "PRIVATE_CELLULAR",
  timezone: "America/Los_Angeles",
  attributes: [],
  edges: [
    {
      edge: {
        id: "",
        name: "",
        type: "",
      },
      ipsecMode: "CERTIFICATE",
    },
  ],
  isCloudGatewayEnabled: false,
};

export const undefinedSite: ISite = {
  name: "",
  description: "",
  location: {
    latitude: 0,
    longitude: 0,
    name: "",
  },
  tacId: "",
  timezone: "",
  attributes: [],
  edges: [],
  isCloudGatewayEnabled: false
};
